export default __webpack_public_path__ + "static/media/tenx-logo.4c330a21.svg";